import { render, staticRenderFns } from "./OtherPartyNprSurvey.vue?vue&type=template&id=256ea02f"
import script from "./OtherPartyNprSurvey.vue?vue&type=script&lang=ts"
export * from "./OtherPartyNprSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports